import { MarkupBaseOperator } from './markup.base.operator';
import { MarkupEllipseItem } from '../markup-items/markup.ellipse.item';

export class MarkupEllipseOperator extends MarkupBaseOperator {
    private _handleFirstPoint = Communicator.Point2.zero();
    public constructor(viewer: Communicator.WebViewer) {
        super(viewer);
    }

    public createMarkupItem(position: Communicator.Point2): void {
        const view = this._viewer.view;
        this._handleFirstPoint = position;
        const cameraPoint = view.getCamera().getCameraPlaneIntersectionPoint(position, view);
        this._markupItem = new MarkupEllipseItem(this._viewer);
        this._markupItem.setLineFormat(this._lineColor, this._lineWeight, this._lineOpacity, this._fillColor, this._fillColorOption, this._lineStyle);
        const itemId = this._viewer.markupManager.registerMarkup(this._markupItem);
        this._markupItem.setMarkupItemId(itemId);
        if (cameraPoint !== null) {
            (this._markupItem as MarkupEllipseItem).setPosition(cameraPoint);
            (this._markupItem as MarkupEllipseItem).setRadiusPoint(cameraPoint);
        }
    }

    public updateMarkupItem(position: Communicator.Point2): void {
        if (this._markupItem) {
            const view = this._viewer.view;

            const pos = position.copy();

            const cameraPoint = view.getCamera().getCameraPlaneIntersectionPoint(pos, view);
            if (cameraPoint !== null) {
                (this._markupItem as MarkupEllipseItem).setRadiusPoint(cameraPoint);
                this._viewer.markupManager.refreshMarkup();
            }
        }
    }
}

